import axios from 'axios';

const FALLBACK_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:20007/api'
  : 'https://bufanfk.107.bfwuye.cn/api';

const request = axios.create({
  baseURL: process.env.REACT_APP_API_URL || FALLBACK_BASE_URL,
  timeout: 10000
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

export default request;
